<template>
  <div class="news-item-card">    <div class="news-content">
      <div class="news-header">
        <h3 class="news-title">{{ newsItem.NewsTitle }}</h3>
        <div class="news-date">{{ formatDate(newsItem.Created) }}</div>      </div>
      <p class="news-short">{{ newsItem.NewsShort }}</p>
      <router-link :to="`/news-detail/${newsItem.NewsID}/${slugify(newsItem.NewsTitle)}`" class="news-read-more">
        <span class="read-more-text">Read more</span>
        <i class="material-icons read-more-icon">arrow_forward</i>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsCard',
  props: {
    newsItem: {
      type: Object,
      required: true
    }
  },
  methods: {    slugify(text) {
      return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-')       // Replace spaces with -
        .replace(/[^\w\-]+/g, '')   // Remove all non-word chars
        .replace(/\-\-+/g, '-')     // Replace multiple - with single -
        .replace(/^-+/, '')         // Trim - from start of text
        .replace(/-+$/, '');        // Trim - from end of text
    },
    formatDate(dateString) {
      if (!dateString) return '';
      
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString; // Return original if invalid
      
      const day = date.getDate();
      const month = date.toLocaleString('en-US', { month: 'long' });
      const year = date.getFullYear();
      
      return `${day} ${month} ${year}`;
    }
  }
};
</script>

<style scoped>
.news-item-card {
  padding: 20px;
  border-radius: 8px;
  background-color: #f9f9f9;
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #eaeaea;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.news-item-card:hover {
  background-color: #f0f5ff;
  transform: translateY(-3px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  border-color: rgba(21, 101, 192, 0.15);
}

.news-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 10px;
}

.news-header {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

.news-title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: #00205b;
  line-height: 1.3;
}

.news-short {
  margin: 0;
  color: #555;
  font-size: 0.95rem;
  line-height: 1.5;
  flex-grow: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}

.news-date {
  font-size: 0.8rem;
  color: #888;
  margin-top: 5px;
}

.news-read-more {
  color: #1565c0;
  font-weight: 500;
  font-size: 0.9rem;
  text-decoration: none;
  align-self: flex-end;
  transition: all 0.3s ease;
  margin-top: auto;
  padding: 6px 12px;
  border-radius: 4px;
  background-color: rgba(21, 101, 192, 0.05);
  display: inline-flex;
  align-items: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
}

.news-read-more:hover {
  color: #0d47a1;
  background-color: rgba(21, 101, 192, 0.15);
  transform: translateY(-2px);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
}

.read-more-icon {
  font-size: 1rem;
  margin-left: 4px;
  transition: transform 0.3s ease;
}

.news-read-more:hover .read-more-icon {
  transform: translateX(4px);
}

.read-more-text, .read-more-icon {
  position: relative;
  z-index: 2;
}

.news-read-more:before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg, 
    transparent, 
    rgba(21, 101, 192, 0.2), 
    transparent
  );
  transition: all 0.6s ease;
  z-index: 1;
  opacity: 0.7;
}

.news-read-more:hover:before {
  animation: linkShimmer 2s ease-in-out infinite;
}

@keyframes linkShimmer {
  0% {
    left: -100%;
    opacity: 0.7;
  }
  50% {
    opacity: 0.9;
  }
  100% {
    left: 100%;
    opacity: 0.7;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NewsCard.vue